module.exports = __webpack_public_path__ + "img/laptop-three.85d7ffbc.png";